import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-force-logout-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './force-logout-popup.component.html',
  styleUrl: './force-logout-popup.component.scss',
})
export class ForceLogoutPopupComponent {
  @Input() visible: boolean = false;
  @Input() message: string = '';
  @Output() confirm = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();
  }
}
